import Backend from 'backend';
import {inject} from 'aurelia-framework';
import {FeatureCustomizationProvider} from "../util/feature-customization-provider";
import {UserInfoProvider} from "../util/user-info-provider";

@inject(Backend, FeatureCustomizationProvider, UserInfoProvider)
export class CustomerPortalOrderIndexScreen {
  backend;
  orders = [];
  highlightOrderId;
  featureCustomizationProvider;
  userInfoProvider;

  constructor(backend, featureCustomizationProvider, userInfoProvider) {
    this.backend = backend;
    this.featureCustomizationProvider = featureCustomizationProvider;
    this.userInfoProvider = userInfoProvider;
  }

  activate(params) {
    this.highlightOrderId = params.highlightOrderId;
    return this.refresh();
  }

  refresh() {
    let customerId = this.userInfoProvider.getInfo().customerIdForCustomerPortal;
    return this.backend.CustomerPortalOrderListQueryHandler_handle({customerId: customerId})
      .then(result => this.orders = result.items);
  }

  getCurrentUrl() {
    return window.location.href;
  }
}
